import { gql } from '@apollo/client';

export const fetchOrdersForTransactionAccount = gql`
  query fetchOrdersByTransactionAccountId(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      billingAdmins(searchOptions: $searchOptions) {
        nodes {
          id
          email
        }
      }
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          orderNumber
          billingContactEmail
          created
          contextSubject
          contextSubjectId
          metadata {
            supportTicketNumber
          }
          metadataObj {
            supportTicketNumber
            handNote
            termsOfTransfer
            reasonCode
            newBillingAdmin
            currentBillingAdmin
          }
          orderLineItems {
            nodes {
              lineItemId
              quantity
              type
              skipTrial
              promotions {
                id
                title
                status
                type
                promotionCode
                benefits {
                  subBenefitType
                  value
                  iterations
                  duration
                  benefitType
                }
                promotionWindow {
                  endTime
                  startTime
                }
              }
              offering {
                id
                name
              }
              pricingPlan {
                id
                type
                billingFrequency
              }
              orderTransitionType
              salesTransitionType
              edition
              entitlementId
              entitlementNumber
              parentEntitlementId
              productName
              productId
              orderLineItemsPurchaseMetadata {
                fieldName
                fieldValue
              }
              orderLineItemsAccountModification {
                accountModificationTransactionAccountId
                accountModificationInvoiceGroupId
              }
            }
          }
        }
      }
    }
  }
`;
